import React from "react";

export default function index() {

    function getDate() {
    const today = new Date();
    const year = today.getFullYear();
    return year;
    }
  return (
        <div className="container-fluid background-checked text-white py-2">
            <div className="row">
                <div className="col-md-12">
                    <p className="text-center">© {getDate()} Tez Gum. All rights reserved.</p>
                </div>
            </div>
        </div>


        )}